import React, { Component }  from 'react'
import { Icon, Modal, Button, Tab, Dropdown, Grid } from 'semantic-ui-react'

import SectionStudents from './SectionStudents'
import SectionSubjects from './SectionSubjects'
import SectionStudentsReadCSV from './SectionStudentsReadCSV'
import SectionSubjectsReadCSV from './SectionSubjectsReadCSV'

class SectionsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      code: '',
      levelType: '',
      gradeLevel: '',
      showModal: false,
      sectionId: '',
      sectionStudents: [],
      studentId: '',
      sectionSubjects: [],
      subjectId: '',
      teachers: [],
      teacherId: ''
    };
  }

  closeModal = () => this.setState({ showModal: false, studentId: '', subjectId: '' })

  openModal = () => {
    this.props.getSectionStudents(this.state.sectionId)
    this.props.getSectionSubjects(this.state.sectionId)
    this.setState({ showModal: true })
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  componentDidMount() {
    this.setState({
      name: this.props.section.name,
      code: this.props.section.code,
      levelType: this.props.section.levelType,
      gradeLevel: this.props.section.gradeLevel,
      sectionId: this.props.section.sectionId,
      sectionStudents: this.props.sectionStudents,
      sectionSubjects: this.props.sectionSubjects,
      teachers: this.props.teachers
    })
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      name: newProps.section.name,
      code: newProps.section.code,
      levelType: newProps.section.levelType,
      gradeLevel: newProps.section.gradeLevel,
      sectionId: newProps.section.sectionId,
      sectionStudents: newProps.sectionStudents,
      sectionSubjects: newProps.sectionSubjects,
      teachers: newProps.teachers
    })
  }

  render() {
    let optionsStudents, optionsSubjects, optionsTeachers;
    if (this.props.students) {
      optionsStudents = this.props.students.map((student,index) => {
        const studentName = student.lastName + ', '+ student.firstName;
        return (
            { key: student.studentId, value: student.studentId, text: studentName }
        )
      })
    }

    if (this.props.subjects) {
      optionsSubjects = this.props.subjects.map((subject,index) => {
        return (
            { key: subject.subjectId, value: subject.subjectId, text: subject.name }
        )
      })
    }

    if (this.props.teachers) {
      optionsTeachers = this.props.teachers.map((teacher,index) => {
        const teacherName = teacher.lastName + ', '+ teacher.firstName;
        return (
            { key: teacher.teacherId, value: teacher.teacherId, text: teacherName }
        )
      })
    }

    const panes = [
      { menuItem: 'Students', render: () =>
        <Tab.Pane>
          <Grid>
            <Grid.Column width={7}>
              <Dropdown
                search
                selection
                fluid
                clearable
                name='studentId'
                className='student-dropdown'
                options={optionsStudents}
                onChange={this.handleChange}
                value={this.state.studentId}
              />
            </Grid.Column>
            <Grid.Column width={9}>

              <Button.Group floated='right'>
                {
                  this.state.studentId === '' ?
                  <Button
                    color='green'
                    onClick={() => this.props.handleSubmitSectionStudent(this.state.studentId, this.state.sectionId)}
                    icon labelPosition='left'
                    disabled
                  ><Icon name='add' />
                    Add Student
                  </Button> :
                  <Button
                    color='green'
                    onClick={() => this.props.handleSubmitSectionStudent(this.state.studentId, this.state.sectionId)}
                    icon labelPosition='left'
                  ><Icon name='add' />
                    Add Student
                  </Button>
                }
                <Button.Or />
                <SectionStudentsReadCSV
                  sectionId={this.state.sectionId}
                  handleFileChange={this.props.handleFileChange}
                  handleDataSaveStudents={this.props.handleDataSaveStudents}
                />
              </Button.Group>
            </Grid.Column>
          </Grid>
          <SectionStudents
            sectionStudents={this.state.sectionStudents}
            handleDeleteSectionStudent={this.props.handleDeleteSectionStudent}
          />
        </Tab.Pane>
      },
      { menuItem: 'Subjects', render: () =>
        <Tab.Pane>
          <Grid>
            <Grid.Column width={4}>
              <Dropdown
                search
                selection
                fluid
                clearable
                name='subjectId'
                placeholder='Subjects'
                className='subject-dropdown'
                options={optionsSubjects}
                onChange={this.handleChange}
                value={this.state.subjectId}
              />
            </Grid.Column>

            <Grid.Column width={5}>
              <Dropdown
                search
                selection
                fluid
                clearable
                name='teacherId'
                placeholder='Teachers'
                className='teacher-dropdown'
                options={optionsTeachers}
                onChange={this.handleChange}
                value={this.state.teacherId}
              />
            </Grid.Column>

            <Grid.Column width={7}>
                <Button.Group floated='right'>
                  {
                    this.state.subjectId === '' || this.state.teacherId === '' ?
                    <Button
                      color='green'
                      onClick={() => this.props.handleSubmitSectionSubject(this.state.subjectId, this.state.sectionId, this.state.teacherId)}
                      icon labelPosition='left'
                      disabled
                    ><Icon name='add' />
                      Add Subject
                    </Button> :
                    <Button
                      color='green'
                      onClick={() => this.props.handleSubmitSectionSubject(this.state.subjectId, this.state.sectionId, this.state.teacherId)}
                      icon labelPosition='left'
                    ><Icon name='add' />
                      Add Subject
                    </Button>
                  }
                  <Button.Or />
                  <SectionSubjectsReadCSV
                    sectionId={this.state.sectionId}
                    handleFileChange={this.props.handleFileChange}
                    handleDataSaveSubjects={this.props.handleDataSaveSubjects}
                  />
                </Button.Group>
            </Grid.Column>
          </Grid>
          <SectionSubjects
            levelType={this.state.levelType}
            optionsTeachers={optionsTeachers}
            sectionSubjects={this.state.sectionSubjects}
            handleDeleteSectionSubject={this.props.handleDeleteSectionSubject}
            handleUpdateSectionSubject={this.props.handleUpdateSectionSubject}
          />
        </Tab.Pane>
      },
    ]
    return (
      <Modal
        trigger={
          <Button icon size='tiny' onClick={this.openModal}>
            <Icon name='eye' />
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        centered={false}
        size='large'
        closeIcon
        >
        <Modal.Header>
          {this.state.gradeLevel} - {this.state.name} ({this.props.section.teacher ? 
            this.props.section.teacher.firstName + ' ' + this.props.section.teacher.lastName : 
            'No Teacher Assigned'})
          <span className='section-level-type'>{this.state.levelType}</span>
        </Modal.Header>
        <Modal.Content>
          <Tab panes={panes} />
        </Modal.Content>
        <Modal.Actions>

        </Modal.Actions>
      </Modal>
    )
  }
};

export default SectionsView;
